import { useRef } from 'react'

type IUseDebounceFn = (...args) => void

function useDebounceFn(fn: (...args) => void, delay: number): IUseDebounceFn {
  const timeoutRef = useRef(null)

  const debounceFn = (...args) => {
    clearTimeout(timeoutRef.current)

    timeoutRef.current = setTimeout(() => {
      fn(...args)
    }, delay)
  }

  return debounceFn
}

export default useDebounceFn
